const Loading = () => (
  <div className="min-h-screen bg-background">
    <div className="flex h-screen items-center justify-center">
      <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent"></div>
    </div>
  </div>
)

export default Loading